const sidenav = {
  en: {
    translation: {
      dashboard: "Dashboard",
      analytics: "Analytics",
      analytics_stealer: "Analytics stealer",
      analytics_ransomware: "Analytics ransomware",
      ransomware: "Ransomware",
      stealers: "Stealers",
      combos: "Combos",
      stealers_to_manage: "Stealers to manage",
      duplicate_stealers: "Duplicate stealers",
      lens_phishing: "Lens Phishing",
      admin: "Admin",
      worker: "Worker",
      userlist: "Userlist",
      add_user: "Add user",
      customers_list: "Customers list",
      add_customer: "Add customer",
      logs: "Logs",
      apikeys: "Apikeys",
      email: "Email",
      alerts: "Alerts",
      credentials: "Credentials",
      passwords: "Identity and Devices",
      reportsrequests: "Requests report",
      reports: "Reports",
      messages: "Notifications sent",
      support: "Support:",
      user: "User Profile",
      codes: "Codes",
      dark_web: "Dark Web",
      data_breach: "Data Breaches",
      phishing: "Phishing",
      clients_stats: "Clients stats",
      sellers: "Sellers",
      activities_to_view: "activities to view",
      services_packages: "Services packages",
      help: "Help",
      itdr: "ITDR",
      phishing_canary_whitelist: "Phishing Canary",
    },
  },
  it: {
    translation: {
      dashboard: "Dashboard",
      analytics: "Statistiche",
      analytics_stealer: "Statistiche stealer",
      analytics_ransomware: "Statistiche ransomware",
      ransomware: "Ransomware",
      stealers: "Stealer",
      combos: "Combo",
      stealers_to_manage: "Stealer da gestire",
      duplicate_stealers: "Stealers duplicati",
      lens_phishing: "Lens Phishing",
      admin: "Amministrator",
      worker: "Worker",
      userlist: "Lista utenti",
      add_user: "Aggiungi utente",
      customers_list: "List clienti",
      add_customer: "Aggiungi cliente",
      logs: "Log",
      apikeys: "Apikeys",
      email: "Email",
      alerts: "Allerte",
      credentials: "Credenziali",
      passwords: "Identità e Dispositivi",
      reportsrequests: "Richieste report",
      reports: "Reports",
      messages: "Notifiche inviate",
      support: "Supporto:",
      user: "Profilo Utente",
      codes: "Codici",
      dark_web: "Dark Web",
      data_breach: "Data Breaches",
      phishing: "Phishing",
      clients_stats: "Statistiche clienti",
      sellers: "Venditori",
      activities_to_view: "attività da vedere",
      services_packages: "Pacchetti servizi",
      help: "Aiuto",
      itdr: "ITDR",
      phishing_canary_whitelist: "Phishing Canary",
    },
  },
};

export default sidenav;
